<template>
    <v-card>
        <v-toolbar density="compact" color="bgSecondary">
            <v-toolbar-title>
                {{ $t("company.document") }} {{ index + 1 }}
            </v-toolbar-title>
            <v-toolbar-items>
                <v-btn
                    v-if="canEdit"
                    icon
                    size="small"
                    elevation="0"
                    color="error"
                    @click="$emit('delete', doc.id)"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <a
                :href="doc.url"
                target="_blank"
                class="text-decoration-underline"
            >
                {{ getFileName(doc.url) }}
            </a>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "DocumentCard",
    props: {
        doc: Object,
        index: Number,
        canEdit: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        getFileName(url) {
            return url.split("/").pop();
        },
    },
};
</script>
